"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { COPYRIGHT_YEAR } from "@/lib/constants";

const ROUTE_PREFIXES_TO_SHOW_FOOTER = [
  "/myAccount",
  "/myCards",
  "/myTemplates",
  "/privacy",
  "/stripe",
  "/tos",
  "/about",
  "/cookies",
  "/policies",
  "/fathersday",
];

const Footer = () => {
  const pathname = usePathname();
  const showFooter =
    ROUTE_PREFIXES_TO_SHOW_FOOTER.some((item) => {
      return pathname?.startsWith(item);
    }) || pathname === "/";

  if (!showFooter) return null;

  return (
    <footer className="flex w-full flex-row justify-center space-x-2 p-2">
      <span className="text-xs text-gray-500">© WrapDotGifts, Inc. {COPYRIGHT_YEAR}</span>
      <Link
        href="https://about.wrapdotgifts.com"
        className="text-xs text-gray-500 hover:text-gray-700"
      >
        About Us
      </Link>
      <Link
        href="/policies"
        className="text-xs text-gray-500 hover:text-gray-700"
      >
        Policies
      </Link>
      {/* Links to the on-page FAQ at the home page's #faq anchor. Named
          "eCard FAQ" for AI-engine discovery: "eCard" binds the entity
          to our product and "FAQ" aligns with the FAQPage JSON-LD at the
          target, so crawlers can follow footer label → schema-typed Q&A.
          On the home page a plain <a> guarantees native same-page hash
          scrolling; on other footer routes (e.g. /myAccount, /fathersday)
          a <Link> does a client-side nav to `/` and Next scrolls to the
          hash — avoiding a full page reload. */}
      {pathname === "/" ? (
        <a href="/#faq" className="text-xs text-gray-500 hover:text-gray-700">
          eCard FAQ
        </a>
      ) : (
        <Link
          href="/#faq"
          className="text-xs text-gray-500 hover:text-gray-700"
        >
          eCard FAQ
        </Link>
      )}
      <a
        href="#"
        className="termly-display-preferences text-xs text-gray-500 hover:text-gray-700"
        onClick={(e) => {
          e.preventDefault();
          if (typeof window.displayPreferenceModal === "function") {
            window.displayPreferenceModal();
          }
        }}
      >
        Consent Preferences
      </a>
    </footer>
  );
};

export default Footer;
